// ── FORMATTERS ────────────────────────────────────────────────────
export function tkr(val) {
  if (!val || isNaN(val)) return '–';
  return Math.round(val / 1000).toLocaleString('sv-SE') + ' tkr';
}

export function pct(val) {
  if (!val || isNaN(val)) return '–';
  return (val * 100).toFixed(0) + '%';
}

export function fmt(num) {
  if (!num || isNaN(num)) return '–';
  return Math.round(num).toLocaleString('sv-SE');
}

export function fmtMonth(ym) {
  if (!ym) return '';
  const s = String(ym);
  const y = s.slice(0, 4);
  const m = parseInt(s.slice(4, 6), 10);
  return ['','Jan','Feb','Mar','Apr','Maj','Jun','Jul','Aug','Sep','Okt','Nov','Dec'][m] + ' ' + y;
}

export function fmtDate(s) {
  const d = new Date(s);
  return ['Sön','Mån','Tis','Ons','Tor','Fre','Lör'][d.getDay()] + ' ' + d.getDate() + '/' + (d.getMonth() + 1);
}

export function getISOWeek(d) {
  const date = new Date(d);
  date.setHours(0, 0, 0, 0);
  date.setDate(date.getDate() + 3 - (date.getDay() + 6) % 7);
  const week1 = new Date(date.getFullYear(), 0, 4);
  return 1 + Math.round(((date.getTime() - week1.getTime()) / 86400000 - 3 + (week1.getDay() + 6) % 7) / 7);
}

// ── RÄKENSKAPSÅR (jul–jun) — beräknas ALLTID dynamiskt ────────────
// Hårdkodade FY-listor orsakade rollover-buggen 1 juli 2026: hela
// portalen satt fast på RÅ 25/26 när nya året börjat.
export function raStartYear(d = new Date()) {
  return d.getMonth() >= 6 ? d.getFullYear() : d.getFullYear() - 1;
}

// "RÅ 26/27" för innevarande räkenskapsår
export function raLabel(d = new Date()) {
  const y = raStartYear(d);
  return `RÅ ${String(y % 100).padStart(2, '0')}/${String((y + 1) % 100).padStart(2, '0')}`;
}

// ÅrMånad-nycklar för innevarande RÅ: ["202607","202608",...,"202706"]
export function fyMonthKeys(d = new Date()) {
  const startY = raStartYear(d);
  return Array.from({ length: 12 }, (_, i) => {
    const mm = ((6 + i) % 12) + 1;                 // 7,8,...,12,1,...,6
    const yy = mm >= 7 ? startY : startY + 1;
    return `${yy}${String(mm).padStart(2, '0')}`;
  });
}

// Antal ISO-veckor i ett år (53 när 1 jan eller 31 dec är en torsdag)
export function weeksInISOYear(y) {
  const jan1 = new Date(Date.UTC(y, 0, 1)).getUTCDay();
  const dec31 = new Date(Date.UTC(y, 11, 31)).getUTCDay();
  return (jan1 === 4 || dec31 === 4) ? 53 : 52;
}

// ÅrVecka-nycklar (numeriska, t.ex. 202627) för innevarande RÅ: V27 → V26
export function fyWeekKeys(currYrWeek) {
  const y = Math.floor(currYrWeek / 100), w = currYrWeek % 100;
  const startY = w >= 27 ? y : y - 1;
  const n = weeksInISOYear(startY);
  return [
    ...Array.from({ length: n - 26 }, (_, i) => startY * 100 + 27 + i), // V27..V52/53
    ...Array.from({ length: 26 }, (_, i) => (startY + 1) * 100 + 1 + i), // V1..V26
  ];
}

// ── SÄSONGENS VECKOR ──────────────────────────────────────────────
// ISO-år har 53 veckor när 1 jan är torsdag, eller när skottår och 1 jan är
// onsdag. 2026 är ett sådant år: vinter 26/27 går v.44–53 + v.1–17, inte
// v.44–52. Hårdkodat "9 vinterveckor" tappade v.53 (28/12–3/1) helt.
export function isoWeeksInYear(y) {
  const jan1 = new Date(Date.UTC(y, 0, 1)).getUTCDay();
  const leap = (y % 4 === 0 && y % 100 !== 0) || y % 400 === 0;
  return (jan1 === 4 || (leap && jan1 === 3)) ? 53 : 52;
}
export const SOMMAR_VECKOR = Array.from({ length: 18 }, (_, i) => 22 + i);
// y1 = säsongens första kalenderår (vinter 26/27 → 2026)
export function vinterVeckor(y1) {
  const sista = isoWeeksInYear(y1);
  return [
    ...Array.from({ length: sista - 43 }, (_, i) => 44 + i),
    ...Array.from({ length: 17 }, (_, i) => 1 + i),
  ];
}
